import React from "react";
import { Button } from "@mui/material";

const Headeralt = () => {
	const containerStyle = {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		padding: "8px 16px",
	};
	const rightStyle = {
		display: "flex",
		gap: 12,
		alignItems: "center",
	};
	const buttonStyle = {
		textTransform: "none",
		color: "inherit",
		fontSize: 16,
	};

	return (
		<div className="headeralt" style={containerStyle}>
			<h4 style={{ margin: 0 }}>Hand Me Style</h4>
			<div style={rightStyle}>
				<Button style={buttonStyle} component="a" href="/">Home</Button>
				<Button style={buttonStyle} component="a" href="/FashionBazaar">Vendors</Button>
			</div>
		</div>
	);
};

export default Headeralt;
